import { NewTask, TaskType } from '@griply/types';
import { useMutation } from '@tanstack/react-query';
import {
  createTasksWithSubTasks,
  TaskEntry,
} from 'shared/services/backend-api';
import { NewSubTask } from 'shared/types/task';

export const useCreateTasksWithSubTasksMutation = () =>
  useMutation({
    mutationFn: async ({
      taskEntries,
    }: {
      taskEntries: Array<{ task: NewTask; subTasks: NewSubTask[] }>;
    }) => {
      const normalizedEntries: TaskEntry[] = taskEntries.map(
        ({ task, subTasks }) => {
          const taskToCreate = {
            ...task,
            endStrategy: task.endStrategy
              ? {
                  deadline:
                    task.endStrategy.deadline && !task.schedules?.length
                      ? task.endStrategy.deadline
                      : null,
                  completionCount: task.endStrategy.completionCount ?? null,
                }
              : null,
          };

          if ('hideOnTodo' in task) {
            taskToCreate.hideOnTodo =
              task.type === TaskType.Habit ? task.hideOnTodo : null;
          }

          return { task: taskToCreate, subTasks };
        },
      );

      return createTasksWithSubTasks(normalizedEntries);
    },
  });
